import React from 'react';
import { inject, observer } from 'mobx-react';
import { Drawer } from '@lyearn-team/frontend-components';
import { withTheme } from 'emotion-theming';
import ActivityChat from '../ActivityChat';
import * as s from './style';

@withTheme
@inject(stores => ({ model: stores.liveClassModel }))
@observer
class ActivityDrawer extends React.Component {
  renderActivityChat = () => {
    const { model } = this.props;
    const { activity } = model.store;
    const { isPopupVisible } = activity;
    if (!isPopupVisible) {
      return null;
    }

    return <ActivityChat />;
  };

  render() {
    const { model } = this.props;
    const { activity, isMobile } = model.store;
    const { isPopupVisible } = activity;

    if (!isMobile) {
      return null;
    }
    return (
      <Drawer visible={isPopupVisible} className={s.drawer} hideCloseButton={true}>
        {this.renderActivityChat()}
      </Drawer>
    );
  }
}

export default ActivityDrawer;
